import { render, staticRenderFns } from "./ThankYouModal.vue?vue&type=template&id=79606db0&"
import script from "./ThankYouModal.ts?vue&type=script&lang=ts&"
export * from "./ThankYouModal.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports